import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import config from "../../config";
import Labels from "../../services/apiLabels";
import AccountShell from "./AccountShell";
import { getAuthToken, getAuthUserId } from "../../utils/userIdentity";
import { scrollTop } from "../../utils/window";

function ChangePasswordPage({ auth }) {
  const userId = getAuthUserId(auth);
  const token = getAuthToken(auth);
  const [form, setForm] = useState({
    password: "",
    newpassword: "",
    confirmpassword: "",
  });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    scrollTop();
  }, []);

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setMessage(null);
    if (form.newpassword.length < 8) {
      setMessage({
        type: "err",
        text: "New password must be at least 8 characters.",
      });
      return;
    }
    if (form.newpassword !== form.confirmpassword) {
      setMessage({
        type: "err",
        text: "New password and confirmation do not match.",
      });
      return;
    }
    if (!token) {
      setMessage({ type: "err", text: "Please log in again." });
      return;
    }
    setSaving(true);
    try {
      await axios.put(
        `${config.baseUrl}${Labels.changePassword}${userId}/`,
        {
          old_password: form.password,
          new_password: form.newpassword,
        },
        { headers: { Authorization: `Token ${token}` } }
      );
      setForm({ password: "", newpassword: "", confirmpassword: "" });
      setMessage({ type: "ok", text: "Password updated successfully." });
    } catch (e) {
      setMessage({
        type: "err",
        text: "Could not change password. Check your current password and try again.",
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <AccountShell
      title="Change password"
      lead="Update your login password. You will stay signed in after saving."
    >
      {message ? (
        <p
          className={`pi-account-alert pi-account-alert--${
            message.type === "ok" ? "ok" : "err"
          }`}
        >
          {message.text}
        </p>
      ) : null}
      <form className="pi-account-form" onSubmit={onSubmit}>
        <div className="pi-account-field">
          <label htmlFor="current-password">Current password</label>
          <input
            id="current-password"
            type="password"
            name="password"
            autoComplete="current-password"
            value={form.password}
            onChange={onChange}
            required
          />
        </div>
        <div className="pi-account-field">
          <label htmlFor="new-password">New password</label>
          <input
            id="new-password"
            type="password"
            name="newpassword"
            autoComplete="new-password"
            value={form.newpassword}
            onChange={onChange}
            required
          />
        </div>
        <div className="pi-account-field">
          <label htmlFor="confirm-password">Confirm new password</label>
          <input
            id="confirm-password"
            type="password"
            name="confirmpassword"
            autoComplete="new-password"
            value={form.confirmpassword}
            onChange={onChange}
            required
          />
        </div>
        <button type="submit" className="pi-account-btn" disabled={saving}>
          {saving ? "Updating…" : "Update password"}
        </button>
      </form>
    </AccountShell>
  );
}

const mapStateToProps = (state) => ({ auth: state.auth });
export default connect(mapStateToProps)(ChangePasswordPage);
